<template>
  <div class="mobile-orientation+">
    <span>Orientation:{{ orientation }}</span>
  </div>
</template>
<script>
// import SystemInformation from './LandingPage/SystemInformation';
import _ from 'lodash';
export default {
  name: 'mobile-orientation',
  data: function () {
    return {
      orientation: 'dupa',
    };
  },
  created: function () {
    window.addEventListener('orientationchange', this.orientationHandler);
  },
  mounted() {
    this.orientation = this.orientationHandler();
    console.log(this.orientation);
  },
  beforeDestroy: function () {
    window.removeEventListener('orientationchange', this.orientationHandler);
  },
  methods: {
    orientationHandler() {
      if (window.screen.orientation) {
        this.orientation = window.screen.orientation.type;
      }
      // iOS test
      else if (!_.isNil(window.orientation)) {
        switch (window.orientation) {
          case 0:
          // Portrait
          case 180:
            // Portrait (Upside-down)
            this.orientation = 'Portrait';
            break;
          case -90:
          // Landscape (Clockwise)
          case 90:
            // Landscape  (Counterclockwise)
            this.orientation = 'Landscape';
            break;
        }
      } else {
        // The orientation API isn't supported in this browser
        this.orientation = `The orientation API isn't supported in this browser`;
      }
      return this.orientation;
    },
  },
};
</script>

<style></style>
